import { useEffect, useRef, useState } from "react";

/**
 * Animate a number counting up on mount / when value changes.
 * Uses requestAnimationFrame for smoothness. Duration in ms.
 *
 * <CountUp value={44143} format={(n) => `₹${n.toLocaleString('en-IN')}`} />
 */
export default function CountUp({ value, duration = 900, format }) {
  const [display, setDisplay] = useState(0);
  const rafRef = useRef(0);
  const startRef = useRef(0);
  const fromRef = useRef(0);

  useEffect(() => {
    if (typeof value !== "number" || Number.isNaN(value)) {
      setDisplay(0);
      return;
    }
    cancelAnimationFrame(rafRef.current);
    fromRef.current = display;
    startRef.current = performance.now();
    const step = (t) => {
      const elapsed = t - startRef.current;
      const p = Math.min(1, elapsed / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(fromRef.current + (value - fromRef.current) * eased);
      if (p < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, duration]);

  const shown = Math.round(display);
  return <span className="tabular-nums">{format ? format(shown) : shown.toLocaleString("en-IN")}</span>;
}
